export const isUseLocalModel = (): boolean => {
  const hostname = window.location.hostname;
  const port = window.location.port;
  return /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname) && port === "3000";
};